import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import Banner from "./Banner"
import PrivacySection from "./PrivacySection"
import CTASignUpLong from "./CTASignUpLong"
import Footer from "@components/Footer"
import "./index.scss"
import "@styles/global.scss"

const PrivacyPolicy = props => {
  return (
    <div>
      <EngineIDNavBar />
      <Banner />
      <div className={"container-fluid"}>
        <div className={"maxWidth"}>
          <PrivacySection></PrivacySection>
          <CTASignUpLong />
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
